import React from "react";
import { useNavigate } from "react-router-dom";
import {
  ArrowLeft,
  LifeBuoy,
  User,
  MapPin,
  ShoppingBag,
  Home,
  MessageCircle,
  ShieldCheck,
  ChevronDown,
} from "lucide-react";
import "./HelpSupport.css";

export default function HelpSupport() {
  const navigate = useNavigate();

  const topics = [
    {
      icon: User,
      title: "Account & Profile",
      description:
        "Manage your profile, account information and personal details.",
    },
    {
      icon: MapPin,
      title: "Location",
      description:
        "Set or update your location to receive relevant nearby content and services.",
    },
    {
      icon: ShoppingBag,
      title: "Marketplace",
      description:
        "Learn about products, vendors, orders and construction marketplace features.",
    },
    {
      icon: Home,
      title: "Properties",
      description:
        "Get help with buying, selling and renting properties on Civilink.",
    },
    {
      icon: MessageCircle,
      title: "Messages",
      description:
        "Learn how to communicate with professionals, vendors and other users.",
    },
    {
      icon: ShieldCheck,
      title: "Safety & Privacy",
      description:
        "Learn about responsible platform usage, privacy and account security.",
    },
  ];

  return (
    <div className="support-page">

      {/* HEADER */}
      <header className="support-header">

        <button
          className="support-back"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft size={20} />
        </button>

        <div>
          <h1>Help & Support</h1>
          <p>Find answers and get help with Civilink</p>
        </div>

      </header>

      <main>

        {/* HERO */}
        <section className="support-hero">

          <div className="support-hero-icon">
            <LifeBuoy size={32} />
          </div>

          <div>
            <span>CIVILINK SUPPORT</span>

            <h2>
              How can we
              <br />
              help you?
            </h2>

            <p>
              Find information about using Civilink or
              get help when something isn't working as expected.
            </p>
          </div>

        </section>


        {/* TOPICS */}
        <section className="support-section">

          <div className="support-title">
            <span>HELP TOPICS</span>

            <h2>What do you need help with?</h2>
          </div>

          <div className="support-grid">

            {topics.map((topic) => {

              const Icon = topic.icon;

              return (
                <div
                  className="support-card"
                  key={topic.title}
                >

                  <div className="support-card-icon">
                    <Icon size={22} />
                  </div>

                  <div>
                    <h3>{topic.title}</h3>

                    <p>
                      {topic.description}
                    </p>
                  </div>

                </div>
              );

            })}

          </div>

        </section>


        {/* FAQ */}
        <section className="support-section">

          <div className="support-title">
            <span>COMMON QUESTIONS</span>

            <h2>Frequently asked questions</h2>
          </div>

          <div className="support-faq">

            <details>
              <summary>
                How do I change my location?
                <ChevronDown size={18} />
              </summary>

              <p>
                Open your Profile Menu, select Location,
                choose your location using the map or search,
                and confirm your location.
              </p>
            </details>

            <details>
              <summary>
                How do I update my profile?
                <ChevronDown size={18} />
              </summary>

              <p>
                Open Profile from the Profile Menu and update
                the information available in your profile.
              </p>
            </details>

            <details>
              <summary>
                How can I contact a professional or vendor?
                <ChevronDown size={18} />
              </summary>

              <p>
                Use the available communication and enquiry
                options provided on relevant Civilink profiles,
                products and listings.
              </p>
            </details>

            <details>
              <summary>
                I found a problem with Civilink. What should I do?
                <ChevronDown size={18} />
              </summary>

              <p>
                If you experience a technical issue or another
                problem, contact the Civilink team through the
                Contact Us section.
              </p>
            </details>

          </div>

        </section>


        {/* SUPPORT CARD */}
        <section className="support-contact">

          <LifeBuoy size={27} />

          <div>

            <h3>Still need help?</h3>

            <p>
              If you cannot find the answer you are looking for,
              contact the Civilink team.
            </p>

            <button
              onClick={() => navigate("/contact")}
            >
              Contact Civilink
            </button>

          </div>

        </section>

      </main>

    </div>
  );
}